<template>
  <div class="profile-div">
    <div class="pc_mine">
      <div class="account">
        <div class="username">{{ username }}</div>
        <div class="logout"
             @click="logout()">{{$t('home.logout')}}</div>
      </div>
      <div class="dropdown__menu"
           v-bind:class="{ active: show, 'dropdown__menu-left': drop_left }">
        <ul class="dropdown__menu-nav">
          <li class="dropdown__menu-item">
            <div class="dropdown__menu-link"
                 title="My Petal Balance">
              <img class="dropdown__menu-svg"
                   src="static/newVersionImgs/setting_balance.svg" >
              <div class="dropdown__menu-text">
                {{ $t('text.balance') }}
                <div class="dropdown__menu-text-balance">
                  <span>{{ showBalance(userBalance) }}</span>
                </div>
              </div>
            </div>
          </li>
          <li class="dropdown__menu-item">
            <a href="#"
               v-b-modal.dailyRewardModal
               class="dropdown__menu-link"
               title="Daily Reward">
              <img class="dropdown__menu-svg"
                   src="static/newVersionImgs/opt_sign.svg" >
              <div class="dropdown__menu-text">
                {{ $t('home.dailyReward') }}
                <div class="reawrd_tips menu_reawrd_tips"
                     v-show="showGift"></div>
              </div>
            </a>
          </li>
          <li class="dropdown__menu-item">
            <a
              href="#"
              v-b-modal.shareLinkModal
              class="dropdown__menu-link"
              title="My Sharing Link"
            >
              <img class="dropdown__menu-svg"
                   src="static/newVersionImgs/setting_invitation.svg" >
              <div class="dropdown__menu-text">{{ $t('home.invitePeople') }}</div>
            </a>
          </li>
          <li class="dropdown__menu-item">
            <a href="#"
               v-b-modal.feedbackModal
               class="dropdown__menu-link"
               title="Send feedback">
              <img class="dropdown__menu-svg"
                   src="static/newVersionImgs/setting_feedback.svg" >
              <div class="dropdown__menu-text">{{ $t('home.sendFeedback') }}</div>
            </a>
          </li>
          <li class="dropdown__menu-item">
            <a href="#"
               v-b-modal.aboutModal
               class="dropdown__menu-link"
               title="Help">
              <img class="dropdown__menu-svg"
                   src="static/newVersionImgs/setting_about.svg" >
              <div class="dropdown__menu-text">{{ $t('home.about') }}</div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="mobile_mine"
         v-if="!isShowMineFeature">
      <div class="user_profile">
        <img src="/static/newVersionImgs/avatar.png" >
        <span>{{ username }}</span>
      </div>
      <div class="mine_panel">
        <div class="panel_box">
          <div class="balance_box">
            <img src="/static/newVersionImgs/mobile_mine_balance.png"
                 alt >
            <div class="balance_box_text">
              <span>{{ showBalance(userBalance) }}</span>
            </div>
          </div>
          <span>{{$t('text.balance')}}</span>
        </div>
        <div class="panel_box"
             @click="showMineFeature('sign')">
          <div class="sign_box">
            <img src="/static/newVersionImgs/mobile_mine_sign.png"
                 alt >
          </div>
          <span>{{$t('navText.sign')}}</span>
        </div>
        <div class="panel_box"
             @click="showMineFeature('invite')">
          <div class="sign_box">
            <img src="/static/newVersionImgs/mobile_mine_invite.svg"
                 alt >
          </div>
          <span>{{$t('home.invitePeople')}}</span>
        </div>
      </div>
      <div class="mine_menu">
        <van-cell-group :border="false"
                        class="menu_box">
          <van-cell
            is-link
            title
            center
            :border="false"
            size="large"
            :clickable="false"
            class="menu_box_item"
            to="/mineSetting?from=language"
          >
            <template #icon>
              <img
                src="/static/newVersionImgs/mobile_mine_language.svg"
                style="width:31px;height:26px"
              >
              <span style="margin-left:20px;font-size:14px">{{$t('language.language')}}</span>
            </template>
            <template #default>
              <img
                :src="$i18n.locale === 'en' ? '/static/newVersionImgs/opt_language_en.svg' : '/static/newVersionImgs/opt_language_cn.svg'"
                style="width:26px;height:28px"
              >
            </template>
          </van-cell>
          <van-cell
            center
            title
            :border="false"
            size="large"
            class="menu_box_item"
            to="/mineSetting?from=feedback"
          >
            <template #icon>
              <img src="/static/newVersionImgs/setting_feedback.svg"
                   style="width:31px;height:26px" >
              <span style="margin-left:20px;font-size:14px">{{$t('home.sendFeedback')}}</span>
            </template>
          </van-cell>
          <van-cell
            center
            title
            :border="false"
            size="large"
            class="menu_box_item"
            to="/mineSetting?from=about"
          >
            <template #icon>
              <img src="/static/newVersionImgs/setting_about.svg"
                   style="width:31px;height:26px" >
              <span style="margin-left:20px;font-size:14px">{{$t('home.about')}}</span>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="mine_logout"
           @click="logout('mobile')">{{$t('home.logout')}}</div>
      <TabBar :userInfo="userInfo"
              v-if="$route.name === 'Mine'"></TabBar>
    </div>
    <div class="mobile_mine_feature"
         v-else>
      <van-nav-bar
        :border="false"
        class="navBar_setting"
        safe-area-inset-top
        fixed
        @click-left="backMine"
      >
        <template #left>
          <van-icon name="arrow-left"
                    color="#000"
                    size="20"></van-icon>
          <div class="language">{{isShowSign ? $t('navText.sign') : $t('home.invitePeople')}}</div>
        </template>
      </van-nav-bar>
      <div class="dailyReward-container mobile_reward"
           v-if="isShowSign">
        <div class="reward_get reward_bottom mobile_reward_title"
             v-if="getReward>0">
          {{$t('home.getReward')}}
          <div class="reward_get_bottom">{{getReward}}</div>
        </div>
        <div class="reward_mid">
          <div class="img_slot">
            <img class="inner_img"
                 :src="first_img"
                 alt
                 v-if="getReward>0" >
            <img class="out_img"
                 src="../../static/newVersionImgs/default_number.svg"
                 v-else >
          </div>
          <div class="img_slot"
               v-for="item in getReward > 0 ? String(getReward).length-1 : 4"
               :key="item">
            <img
              class="inner_img"
              src="../../static/newVersionImgs/default_0.svg"
              alt
              v-if="getReward>0"
            >
            <img class="out_img"
                 src="../../static/newVersionImgs/default_number.svg"
                 v-else >
          </div>
        </div>
        <div class="sign_pic"
             v-if="getReward>0">
          <img src="/static/newVersionImgs/mobile_feature_sign_pic.svg" >
        </div>
        <div class="reward_bottom mobile_time_box"
             v-if="dailyRewardTimeLeft>0&&getReward==0">
          <div class="reward_bottom_top">{{ $t('account.nextRewardTimeLeft') }}</div>
          <div class="mobile_time">{{ displayDailyRewardTime }}</div>
        </div>
        <div
          :class="[dailyRewardTimeLeft>0?'reward_button reward_button_ban':'reward_button','mobile_sign_btn']"
          @click="dailyRewardTimeLeft>0?'':getUserDailyReward()"
          style="margin-top:40px;cursor:pointer"
          v-if="getReward==0"
        >{{$t('navText.signText')}}</div>
      </div>
      <div class="mobile_invite"
           v-else>
        <div class="invite_pic">
          <img src="/static/newVersionImgs/mobile_feature_invite_pic.svg" >
        </div>
        <div class="invite_text">{{$t('home.inviteDscription')}}</div>
        <div style="background: #ffeeee;width:100%;padding-bottom:30px">
          <div
            class="reward_button"
            v-b-modal.shareLinkModal
            style="margin-top:100px;cursor:pointer"
          >{{$t('home.invitePeople')}}</div>
        </div>
      </div>
    </div>
    <b-modal
      id="shareLinkModal"
      title="My Share Link"
      ref="shareLinkModal"
      centered
      ok-only
      hide-header
      hide-footer
    >
      <div class="shareLink-container">
        <div class="share_title">
          {{ $t('home.invitePeople') }}
          <div class="close_btn"
               @click="$refs.shareLinkModal.hide()">x</div>
        </div>
        <div class="rule_div">
          {{$t('newTextForm.invateRule')}}
          <div class="rule_line"></div>
        </div>
        <div class="share_text">{{ $t('home.inviteDscription') }}</div>
        <div class="p-10"
             v-if="isMobileApp">
          <button @click="inviteFromApp('twitter')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/twitter-logo.jpeg" >
          </button>
          <button @click="inviteFromApp('wechat')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/wechat-logo.png" >
          </button>
          <button @click="inviteFromApp('instagram')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/instagram-logo.jpg" >
          </button>
          <button @click="inviteFromApp('facebook')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/facebook-logo.png" >
          </button>
          <button @click="inviteFromApp('weibo')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/weibo-logo.jpg" >
          </button>
          <button @click="inviteFromApp('qq')"
                  tabindex="-1"
                  class="invite-app-btn">
            <img class="invite-app-img"
                 src="static/images/qq-logo.jpg" >
          </button>
        </div>
        <!-- <textarea
          v-else
          class="share-url-input p-10"
          v-model="shareURL"
          ref="urlToCopy"
          rows="2"
          readonly>
        </textarea>-->
        <el-input v-model="shareURL"
                  ref="urlToCopy"
                  :disabled="true"></el-input>
        <div class="copy_btn"
             @click="copyShareLink">{{ $t('home.copy') }}</div>
      </div>
      <div class="close-share-btn">
        <!-- <b-button
          v-if="!isMobileApp"
          variant="outline-success"
          class="m-10"
          @click="copyShareLink">
          {{ $t('home.copy') }}
        </b-button>
        <b-button
          variant="outline-dark"
          class="m-10"
          @click="closeShareModal">
          {{ $t('home.close') }}
        </b-button>-->
      </div>
    </b-modal>
    <b-modal
      id="aboutModal"
      title="About"
      ref="aboutModal"
      centered
      ok-only
      hide-header
      hide-footer
    >
      <button class="close btn-close"
              @click="closeAboutModal">
        <b-icon-x></b-icon-x>
      </button>
      <div class="aboutPetal-container">
        <div class="top_logo">
          <img src="/static/newVersionImgs/login_top.svg" >
        </div>
        <div class="version_top">
          <div class="top_line"></div>
          <div class="version_text">
            <div>{{ $t('home.about') }} Petal</div>
            <div>{{ $t('home.version') }} {{ version }}</div>
          </div>
          <div class="top_line"></div>
        </div>
        <div class="petal-description m-3">{{ $t('home.introduction') }}</div>
        <div class="petal-description m-3">
          {{ $t('home.giftSpec') }}
          <b-table striped
                   bordered
                   class="mt-1"
                   small
                   :fields="giftTableHeader"
                   :items="gifts"></b-table>
        </div>
        <div class="petal-description m-3 rule-text">{{ $t('guide.ruleText') }}</div>
        <div class="right-reserved m-3">{{ $t('home.devlopedBy') }}</div>
      </div>
    </b-modal>
    <b-modal id="languageModal"
             :title="$t('text.language')"
             ref="languageModal"
             centered
             ok-only>
      <div class="about-container">
        <b-button variant="info"
                  class="m-2"
                  @click="$i18n.locale='en'">English</b-button>
        <b-button variant="info"
                  class="m-2"
                  @click="$i18n.locale='cn'">简体中文</b-button>
      </div>
    </b-modal>
    <b-modal
      id="feedbackModal"
      :title="$t('home.sendFeedback')"
      ref="feedbackModal"
      centered
      hide-footer
      hide-header
    >
      <div class="shareLink-container">
        <!-- <b-button variant="info"
                  class="m-3 modal-icon-text"
                  href="mailto:petal.developer@gmail.com">
          <b-icon-envelope class="dropdown__menu-svg"></b-icon-envelope>
          Email
        </b-button>
        <b-button variant="info"
                  class="m-3 modal-icon-text"
                  href="https://www.facebook.com/dv.petal"
                  target="_blank">
          <img class="dropdown__menu-svg"
               src="static/images/facebook-logo.png">
          Facebook
        </b-button>-->
        <div class="share_title">
          {{$t('home.sendFeedback')}}
          <div @click="$refs.feedbackModal.hide()"
               class="close_btn">x</div>
        </div>
        <div class="feed_line"
             @click="feedbbackOpt('https://www.facebook.com/dv.petal')">
          <img class="dropdown__menu-svg"
               src="static/images/facebook-logo.png" >
          <div class="feed_text">{{'facebook'}}</div>
          <div></div>
        </div>
        <div class="feed_line"
             @click="feedbbackOpt('mailto:petal.developer@gmail.com')">
          <b-icon-envelope class="dropdown__menu-svg"></b-icon-envelope>
          <div class="feed_text">{{'e-mail'}}</div>
          <div></div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="dailyRewardModal"
      :title="$t('home.dailyReward')"
      ref="dailyRewardModal"
      centered
      ok-only
      hide-footer
      hide-header
      @hide="hideRewardModal"
    >
      <div class="dailyReward-container">
        <div class="reward_title">
          <div style="width:50px;"></div>
          <div>{{$t('home.dailyReward')}}</div>
          <div @click="isShowQues=!isShowQues"
               style="cursor:pointer">
            <img
              :src="isShowQues?'../../static/newVersionImgs/close_ques.svg':'../../static/newVersionImgs/show_ques.svg'"
              alt
            >
          </div>
        </div>
        <div v-if="!isShowQues">
          <div class="reward_mid">
            <div class="img_slot">
              <img class="inner_img"
                   :src="first_img"
                   v-if="getReward>0" >
              <img class="out_img"
                   src="../../static/newVersionImgs/default_number.svg"
                   v-else >
            </div>
            <div class="img_slot"
                 v-for="item in getReward > 0 ? String(getReward).length-1 : 4"
                 :key="item">
              <img
                class="inner_img"
                src="../../static/newVersionImgs/default_0.svg"
                v-if="getReward>0"
              >
              <img class="out_img"
                   src="../../static/newVersionImgs/default_number.svg"
                   v-else >
            </div>
          </div>
          <div class="reward_get reward_bottom"
               v-if="getReward>0">
            {{$t('home.getReward')}}
            <div class="reward_get_bottom">{{getReward}}</div>
          </div>
          <div
            :class="[dailyRewardTimeLeft>0?'reward_button reward_button_ban':'reward_button']"
            @click="dailyRewardTimeLeft>0?'':getUserDailyReward()"
            style="margin-top:40px;cursor:pointer"
            v-if="getReward==0"
          >{{$t('navText.signText')}}</div>
          <div class="reward_bottom"
               v-if="dailyRewardTimeLeft>0&&getReward==0">
            <div class="reward_bottom_top">{{ $t('account.nextRewardTimeLeft') }}:</div>
            <div>{{ displayDailyRewardTime }}</div>
          </div>
        </div>
        <div v-else
             style="margin-top:30px;">{{ $t('guide.ruleText') }}</div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getBaseUrl, getUserInfo, getDailyReward } from '@/utils/api'
import { VERSION, SMALL_GIFT, MIDDLE_GIFT, BIG_GIFT } from '@/constants'
import { displayBalance, secondsToHHMMSS } from '@/utils/common'
import TabBar from '@/components/TabBar'

export default {
    data: function() {
        return {
            show: false,
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            isWebsite: process.env.PLATFORM === 'website',
            dailyRewardTimeLeft: 0,
            version: VERSION,
            showGift: false,
            getReward: 0,
            first_img: '../../static/newVersionImgs/default_0.svg',
            isShowQues: false,
            isShowMineFeature: false,
            isShowSign: true
        }
    },
    created() {
        setInterval(this.updateDailyRewardTimeLeft, 1000)
        this.backToHome()
        if (this.userInfo) {
            this.updateUserInfo()
        } else {
            if (this.$route.name === 'Mine') {
                this.$router.push('/login?login=1&from=home')
            }
        }
        this.isShowMineFeature = !!this.$route.query.feature
        this.isShowSign = this.$route.query.feature === 'sign'
    },
    props: {
        drop_left: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        $route() {
            this.isShowMineFeature = !!this.$route.query.feature
            this.isShowSign = this.$route.query.feature === 'sign'
        }
    },
    methods: {
        ...mapActions([
            'setUserInfo',
            'selectVideo',
            'setUserNextRewardTime',
            'setSharedVideoCount',
            'setActivePoint',
            'setUserBalance'
        ]),
        backMine() {
            this.getReward = 0
            this.$router.push(this.$route.query.from ? '/' : '/mine')
        },
        showMineFeature(type) {
            this.isShowMineFeature = true
            this.isShowSign = type === 'sign'
            this.$router.push({
                query: {
                    feature: type
                }
            })
        },
        updateUserInfo() {
            getUserInfo()
                .then(res => {
                    this.setUserInfo(res.data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        logout(type) {
            // this.$confirm('logout', 'title', 'options')
            localStorage.removeItem('user_token')
            localStorage.removeItem('user_token_ts')
            this.setUserInfo(false)
            this.show = false
            if (type === 'mobile') {
                this.$router.push('/')
            }
        },
        hideRewardModal() {
            this.isShowQues = false
            this.getReward = 0
        },
        feedbbackOpt(url) {
            window.open(url)
        },
        showProfile(show) {
            if (this.userInfo) {
                this.show = show
            } else {
                this.$bvModal.show('modal-login')
                this.show = false
            }
        },
        showBalance(petalBalance, precision = 0) {
            return displayBalance(petalBalance, precision)
        },
        inviteFromApp(app) {
            if (!this.isMobileApp || typeof window.plugins === 'undefined') {
                return
            }
            let url = this.shareURL
            let message = this.username + ' ' + this.$t('home.inviteMsg') + '\n'
            let msgWithURL = message + url
            if (app === 'twitter') {
                window.plugins.socialsharing.shareViaTwitter(
                    message,
                    null /* img */,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'facebook') {
                window.plugins.socialsharing.shareViaFacebookWithPasteMessageHint(
                    msgWithURL,
                    null /* img */,
                    null,
                    'Paste it!',
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'weibo') {
                window.plugins.socialsharing.shareVia(
                    'com.sina.weibo',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'wechat') {
                window.plugins.socialsharing.shareVia(
                    'com.tencent.mm',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'instagram') {
                window.plugins.socialsharing.shareViaInstagram(
                    msgWithURL,
                    null,
                    this.shareSuccess,
                    this.shareFailed
                )
            } else if (app === 'qq') {
                window.plugins.socialsharing.shareVia(
                    'com.tencent.mobileqq',
                    message,
                    null,
                    null,
                    url,
                    this.shareSuccess,
                    this.shareFailed
                )
            }
        },
        shareSuccess() {
            console.log('share ok')
        },
        shareFailed(msg) {
            alert(this.$t('text.error') + ': ' + this.$t('share.shareError'))
        },
        closeAboutModal() {
            this.$refs.aboutModal.hide()
        },
        closeShareModal() {
            this.$refs.shareLinkModal.hide()
        },
        copyShareLink() {
            // this.$refs.urlToCopy.select()
            // window.document.execCommand('copy')
            navigator.clipboard.writeText(this.shareURL)
        },
        getUserDailyReward() {
            if (!this.userInfo) {
                return
            }
            getDailyReward(this.activePoint)
                .then(res => {
                    if (res.data.status === 'ok') {
                        this.setSharedVideoCount(0)
                        this.setActivePoint(0.0001)
                        this.setUserBalance(res.data.balance)
                        this.setUserNextRewardTime(res.data['next_timestamp'])
                        let referralReward = res.data['accumulated_referral_reward']
                        if (referralReward > 0) {
                            alert(
                                this.$t('home.getDaliyAndReferralReward', {
                                    daily: res.data.reward,
                                    referral: referralReward
                                })
                            )
                        } else {
                            // alert(this.$t('home.getReward') + res.data.reward)
                        }
                        let tmp = (res.data.reward + '').substring(0, 1)
                        this.first_img =
              '../../static/newVersionImgs/default_' + tmp + '.svg'
                        this.getReward = res.data.reward
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateDailyRewardTimeLeft() {
            if (
                this.userInfo &&
        this.userInfo['next_reward'] > this.nextDailyRewardTime
            ) {
                this.setUserNextRewardTime(this.userInfo['next_reward'])
            }
            let now = Math.round(new Date().getTime() / 1000)
            if (this.nextDailyRewardTime > now) {
                this.dailyRewardTimeLeft = this.nextDailyRewardTime - now
                this.showGift = false
            } else {
                this.dailyRewardTimeLeft = 0
                this.showGift = !!this.userInfo
            }
            this.backToHome()
        },
        backToHome() {
            if (document.body.clientWidth > 768 && this.$route.name === 'Mine') {
                this.$router.push('/')
            }
        },
        openShareModal() {
            this.$router.push('/shareVideo')
        }
    },
    computed: {
        ...mapGetters([
            'userInfo',
            'userBalance',
            'currentVideo',
            'nextDailyRewardTime',
            'activePoint'
        ]),
        username() {
            return this.userInfo ? this.userInfo.name : 'User'
        },
        shareURL() {
            if (this.userInfo) {
                return getBaseUrl() + '/#/?code=' + this.userInfo.ref_code
            } else {
                return '(Please login to get your share link)'
            }
        },
        displayDailyRewardTime() {
            return secondsToHHMMSS(this.dailyRewardTimeLeft)
        },
        gifts() {
            return [
                {
                    type: this.$t('video.smallGift'),
                    cost: SMALL_GIFT + ' ' + this.$t('text.petal'),
                    effects: this.$t('video.smallPresentTips')
                },
                {
                    type: this.$t('video.middleGift'),
                    cost: MIDDLE_GIFT + ' ' + this.$t('text.petal'),
                    effects: this.$t('video.middlePresentTips')
                },
                {
                    type: this.$t('video.bigGift'),
                    cost: BIG_GIFT + ' ' + this.$t('text.petal'),
                    effects: this.$t('video.bigPresentTips')
                }
            ]
        },
        giftTableHeader() {
            return [
                {
                    key: 'type',
                    label: this.$t('text.type'),
                    thStyle: { minWidth: '50px' }
                },
                {
                    key: 'cost',
                    label: this.$t('text.cost'),
                    thStyle: { minWidth: '100px' }
                },
                {
                    key: 'effects',
                    label: this.$t('text.effects'),
                    thStyle: { minWidth: '100px' }
                }
            ]
        }
    },
    components: {
        TabBar
    }
}
</script>
<style lang="scss" scoped>
.profile-div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .pc_mine {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile_mine {
    display: none;
  }
  .mobile_mine_feature {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .profile-div {
    margin: 0;
    position: absolute;
    top: 0;
    background: #ffeeee;

    .pc_mine {
      display: none;
    }
    .mobile_mine {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url("/static/newVersionImgs/nav_background.svg") no-repeat;
      background-size: contain;

      .user_profile {
        width: 90%;
        text-align: left;
        margin-top: 49px;
        img {
          width: 42px;
          height: 41px;
        }

        span {
          font-weight: bold;
          font-size: 14px;
          margin-left: 20px;
        }
      }

      .mine_panel {
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 60px;

        .panel_box {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          font-size: 13px;
          height: 130px;

          .balance_box {
            img {
              width: 99px;
              height: 86px;
            }

            .balance_box_text {
              position: relative;
              bottom: 5px;
              height: 25px;
              border-radius: 8px;
              padding: 0 10px 0 10px;
              background: linear-gradient(top, #f7a2a2, #ec6969);
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;

              span {
                text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
                font-weight: bold;
                font-size: 15px;
              }
            }
          }

          .sign_box {
            img {
              width: 85px;
              height: 95px;
            }
          }
        }
      }

      .mine_menu {
        width: 95%;
        margin-top: 40px;
        border-radius: 24px;
        background-color: #fff;
        box-shadow: 0 10px 20px 0 rgba($color: #000000, $alpha: 0.1);
        padding: 10px;

        .menu_box {
          background: transparent;

          .menu_box_item {
            background: transparent;
          }
        }
      }

      .mine_logout {
        width: 100%;
        margin-top: 60px;
        color: #998e8e;
        font-size: 14px;
        background: #ffeeee;
        padding-bottom: 200px;
      }
    }

    .mobile_mine_feature {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: url("/static/newVersionImgs/nav_background_sec.svg") no-repeat;
      background-size: contain;

      .navBar_setting {
        width: 100%;
        background: transparent;

        .language {
          font-size: 18px;
          font-weight: bold;
          margin-left: 10px;
        }

        .btn_setting {
          width: 60px;
          height: 32px;
          text-align: center;
          line-height: 32px;
          border-radius: 36px;
          color: #ffffff;
          font-size: 14px;
          background: linear-gradient(left, #f59595, #e03232);
        }
      }

      .mobile_reward {
        width: 100%;

        .reward_mid {
          position: absolute;
          top: 180px;
          left: 0;
          right: 0;
          margin: 0 auto;
          .img_slot {
            .out_img {
              width: 100%;
              height: 120px;
            }
            .inner_img {
              width: 100%;
              height: 120px;
              position: relative;
              margin: 0;
            }
          }
        }

        .sign_pic {
          position: absolute;
          top: 250px;
          left: 0;
          right: 0;
          margin: 0 auto;
          img {
            width: 250px;
            height: 450px;
          }
        }

        .mobile_time_box {
          position: absolute;
          top: 450px;
          left: 0;
          right: 0;
          margin: 0 auto;

          .reward_bottom_top {
            color: #d94e4e;
            font-size: 16px;
            font-weight: bold;
          }

          .mobile_time {
            color: #d94e4e;
            font-weight: bold;
            font-size: 40px;
          }
        }

        .mobile_reward_title {
          position: absolute;
          top: 70px;
          left: 0;
          right: 0;
          margin: 0 auto;
        }

        .mobile_sign_btn {
          position: absolute;
          bottom: 50px;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
      }

      .mobile_invite {
        width: 100%;
        margin-top: 100px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .invite_pic {
          img {
            width: 210px;
            height: 340px;
          }
        }

        .invite_text {
          width: 80%;
          margin-top: 40px;
          color: #d94e4e;
          font-size: 16px;
          font-weight: bold;
          text-align: left;
        }
        .reward_button {
          width: 200px;
          height: 38px;
          margin: auto;
          background-color: #f06565;
          color: white;
          border-radius: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
.center {
  text-align: center;
}

.account {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  color: #000;
  font-size: 16px;

  .username {
    font-weight: bold;
  }

  .logout {
    cursor: pointer;
  }
}

/* Header Menu */
.header--button-img {
  width: 43px;
}
.header--icon {
  width: 43px;
}
.header--button {
  outline: none;
  padding: 0;
  color: gray;
  cursor: pointer;
  border: 1px solid transparent;
  background-color: transparent;
}
.header--button :focus {
  outline: 0;
}
.header__nav {
  position: relative;
}
.header__navbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  list-style-type: none;
}
.reawrd_tips {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
}
.menu_reawrd_tips {
  right: 176px;
  top: 103px;
}
/* Dropdown Menu */
.dropdown__menu-left {
  right: 10%;
}
.dropdown__menu {
  width: 90%;
  margin-top: 13px;
}

.dropdown__menu-nav {
  padding: 0;
}

.dropdown__menu-item {
  list-style-type: none;
  margin-top: 7px;
  padding: 10px;
  border-radius: 12px;
}

.dropdown__menu-item:hover {
  background-color: #f0f0f0;
}

.shareLink-container {
  .share_title {
    display: flex;
    justify-content: space-between;
    color: #f06565;
    font-size: 22px;
    .close_btn {
      color: black;
      width: 30px;
      text-align: right;
      cursor: pointer;
    }
  }
  .rule_div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999999;
    margin: 20px 0;
    white-space: nowrap;
    font-size: 15px;
    .rule_line {
      border-top: 1px solid #d8d8d8;
      width: 90%;
    }
  }
  .el-input {
    margin: 20px 0;
  }
  .copy_btn {
    width: 160px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f06565;
    color: white;
    border-radius: 22px;
    margin: auto;
    margin-top: 20px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .feed_line {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 300px;
    height: 50px;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    margin: auto;
    margin-top: 30px;
    margin-bottom: 30px;
    cursor: pointer;
    .feed_text {
      width: 150px;
      text-align: center;
    }
  }
}

.aboutPetal-container {
  .top_logo {
    display: flex;
    justify-content: center;
    img {
      margin: auto;
      width: 64px;
      height: 77px;
    }
  }
  .version_top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    .top_line {
      border-top: 1px solid black;
      width: 100px;
    }
    .version_text {
      margin: 0 20px;
      text-align: center;
    }
  }
}
.dailyReward-container {
  padding-bottom: 50px;
  .reward_title {
    display: flex;
    justify-content: space-between;
    color: #f06565;
    font-size: 25px;
    margin-top: 5px;
  }
  .reward_mid {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    overflow: scroll;
    .img_slot {
      display: flex;
      .out_img {
        width: 60px;
        height: 100px;
      }
      .inner_img {
        width: 60px;
        height: 100px;
        // position: absolute;
        // margin: 42px 0 0 32px;
      }
    }
  }
  .reward_button {
    width: 200px;
    height: 38px;
    margin: auto;
    background-color: #f06565;
    color: white;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .reward_button_ban {
    background-color: #cccccc;
  }
  .reward_bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    .reward_bottom_top {
      color: #cccccc;
    }
  }
  .reward_get {
    color: #d94e4e;
    .reward_get_bottom {
      font-size: 40px;
      font-size: 600;
    }
  }
}
.dropdown__menu-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.6);
}

.dropdown__menu-svg {
  width: 1.7rem;
  height: 1.7rem;
}
.dropdown__menu-text {
  width: 80%;
  font-size: 16px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .dropdown__menu-text-balance {
    height: 35px;
    border-radius: 8px;
    padding: 0 10px 0 10px;
    background: linear-gradient(top, #f7a2a2, #ec6969);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;

    span {
      text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      font-weight: bold;
      font-size: 20px;
    }
  }
}

/* Animation Menu Icon */

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

/* Dropdown Menu Animation */

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.5s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

/* Wrapper */

.main {
  margin: 6rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.main__subtitle {
  color: #4f5959;
  font-weight: 100;
  margin-bottom: 2rem;
}
.main__link {
  margin-right: 1.5rem;
  display: inline-block;
}
.main__link :last-child {
  margin-right: 0;
}
.main__svg {
  width: 2rem;
  height: 2rem;
  opacity: 0.6;
  color: #94a2b0;
}
.main__svg :hover {
  color: #ffad1f;
}

.btn-close {
  position: absolute;
  right: 20px;
}
.about-container {
  text-align: center;
}
.about-title {
  color: #181b3a;
  font-size: 34px;
}
.version {
  color: #9091a3;
  font-size: 18px;
}
.about-text {
  margin: 30px 15px 20px 15px;
  color: #4f515e;
  font-size: 15px;
  text-align: left;
}
.right-reserved {
  text-align: center;
  color: #9091a3;
  font-size: 15px;
}
.petal-description {
  text-align: left;
  color: rgb(0, 0, 0);
  font-size: 15px;
}
.btn-copy {
  position: absolute;
  right: 10;
  margin-top: 15px;
}
.close-share-btn {
  width: 100%;
  text-align: center;
}
.m-top-bottom-20 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.m-10 {
  margin: 10px;
}
.p-10 {
  padding: 10px;
}
.left {
  float: left;
}
.share-url-input {
  width: 100%;
}
.language-btn {
  float: right;
  margin-right: 10px;
}
.modal-icon-text {
  font-size: 1.2rem;
}
.invite-app-img {
  width: 46px;
  height: 46px;
}
.invite-app-btn {
  background-color: #fff;
  border: white 1px solid;
  border-radius: 8px;
  margin: 2px;
}
.rule-text {
  white-space: pre-line;
}
@media only screen and (max-width: 768px) {
  .header--button-img {
    width: 25px;
    margin: 10px 0 0px 20px;
  }
  .reawrd_tips {
    top: 3px;
  }
  .menu_reawrd_tips {
    right: 176px;
    top: 103px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue